import { MainLayout } from "@/components/layouts/main-layout";
import { SettingsLayout as _SettingsLayout } from "@/components/layouts/settings-layout";
import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_authenticated/$company/buchhaltung/_settings",
)({
  component: SettingsLayout,
});

function SettingsLayout() {
  return (
    <MainLayout>
      <_SettingsLayout>
        <Outlet />
      </_SettingsLayout>
    </MainLayout>
  );
}
